export const QR_DIAGNOSTICS = {
  SET_LOADING: 'QR_DIAGNOSTICS/SET_LOADING',
  SET_LIST: 'QR_DIAGNOSTICS/SET_LIST',
  SET_ITEM: 'QR_DIAGNOSTICS/SET_ITEM',
  SET_PAGE_OFFSET: 'QR_DIAGNOSTICS/SET_PAGE_OFFSET',
  RESET_TO_DEFAULT: 'QR_DIAGNOSTICS/RESET_TO_DEFAULT',
  CHANGE_SORT_FIELD: 'QR_DIAGNOSTICS/CHANGE_SORT_FIELD',
  UPDATE_CONFIG: 'QR_DIAGNOSTICS/UPDATE_CONFIG',
};

export const META = {
  SET_VERSION: 'META/SET_VERSION',
};

export const DATA = {
  SET_USER_ROLES: 'DATA/SET_USER_ROLES',
  SET_USER_COUNTRIES: 'DATA/SET_USER_COUNTRIES',
};